<template>

  <ValidationObserver v-slot="{ invalid }">
    <b-modal id="AddClient" hide-footer size="xl">
      <template #modal-title> Dodanie nowego klienta</template>
      <form @submit="submitForm">
        <b-row>
          <b-col>
            <validation-provider :rules="`required|max:128`" v-slot="{ errors }">
              <b-form-group label="Nazwa firmy">
                <b-input v-model="userName"/>
                <b-alert class="mt-2" v-if="errors.length > 0" show variant="danger">
                  {{ errors[0] }}
                </b-alert>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <validation-provider :rules="`required|max:24`" v-slot="{ errors }">
              <b-form-group label="Nip">
                <b-input v-model="nip"/>
                <b-alert class="mt-2" v-if="errors.length > 0" show variant="danger">
                  {{ errors[0] }}
                </b-alert>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col>
            <validation-provider :rules="`required`" v-slot="{ errors }">
              <b-form-group label="Kraj">
                <v-select :options="countries" v-model="country" label="name" :reduce="(x) => x.id"/>
                <b-alert class="mt-2" v-if="errors.length > 0" show variant="danger">
                  {{ errors[0] }}
                </b-alert>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <div class="col align-self-end div-form-buttons-area">
          <button class="btn btn-primary" type="submit" :disabled="invalid">
            Zapisz
          </button>

          <button
              class="btn btn-warning"
              type="button"
              @click="ClearFormAndCloseWindow"
          >
            Zamknij
          </button>
        </div>
      </form>
    </b-modal>
  </ValidationObserver>
</template>

<script>
import {ValidationObserver} from 'vee-validate';
import axios from "axios";
import countryMixin from "@/mixins/countryMixin";
import urlConfig from "../../../../mixins/url";
import toastrMixin from "@/mixins/toastr";

export default {
  components: {
    ValidationObserver
  },
  props: ["selectedClient"],
  mixins: [countryMixin, urlConfig, toastrMixin],
  created() {
    this.getCountries();
  },
  data() {
    return {
      id:undefined,
      userName: '',
      country: '',
      nip: '',
    }
  },
  mounted() {

  },

  methods: {
    ClearFormAndCloseWindow() {
      this.$bvModal.hide("AddClient");
      this.userName = '';
      this.country = '';
      this.nip = '';
      this.id = undefined;
    },
    submitForm(evt) {
      evt.preventDefault();
      const url = this.id ? `${process.env.VUE_APP_URL}Client/Update`: `${process.env.VUE_APP_URL}Client/Create`;
      var dataToSend = this.id ? {
        clientId: this.id,
        name: this.userName,
        countryId: this.country,
        nip: this.nip
      } : {
        name: this.userName,
        countryId: this.country,
        nip: this.nip
      };

      var that = this;
      axios
          .post(url, dataToSend)
          .then(function (res) {
            const results = res.data;
            if (results.success) {
              that.ClearFormAndCloseWindow();
              that.$emit("ClientWasAdded");
            } else {
              that.ShowErrorMessage("Błąd przy dodawaniu klienta", "Nie udało się zapisać nowego klienta")
            }
          })
          .catch(function (e) {
            console.log(e);
          });

    },
  },
};
</script>